import React, { Dispatch, SetStateAction, SyntheticEvent } from 'react';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { useTranslation } from 'react-i18next';
import {
    Collapse,
    FormControlLabel,
    List,
    ListItem,
    Switch,
} from '@mui/material';
import { SharedItemUI } from './SharedItemUI';

export const OrganizationSharing = ({
    canRead,
    setCanRead,
    canWrite,
    setCanWrite,
    translationKey,
}: {
    canRead: boolean;
    setCanRead: Dispatch<SetStateAction<boolean>>;
    canWrite: boolean;
    setCanWrite: Dispatch<SetStateAction<boolean>>;
    translationKey: string;
}): React.ReactElement => {
    const { t } = useTranslation();

    const organizationSharingRight = (
        <Collapse in={canRead} timeout="auto" unmountOnExit>
            <List component="div" disablePadding className="dependent">
                <ListItem>
                    <FormControlLabel
                        control={
                            <Switch
                                color="primary"
                                checked={canWrite}
                                onChange={(_, v) => setCanWrite(v)}
                                data-testid="organization-edit"
                            />
                        }
                        label={t('sharingModal.writeAccess')}
                    />
                </ListItem>
            </List>
        </Collapse>
    );

    return (
        <SharedItemUI
            title={t(`sharingModal.organisationSharing`)}
            subtitle={t(`sharingModal.${translationKey}.orgaSharingSubtitle`)}
            isChecked={canRead}
            onCheck={(_: SyntheticEvent<Element, Event>, checked: boolean) =>
                setCanRead(checked)
            }
            enabled
            icon={<AccountBalanceIcon />}
        >
            {organizationSharingRight}
        </SharedItemUI>
    );
};
